<template>
  <div>
    <h2 class="pull-left pb-title w-100 mb-4 fs-5">{{ $t('account.log_in') }}</h2>

    <!-- TODO: @lames error styling -->
    <div v-show="errors.has('auth')" class="alert alert-error alert alert-danger pull-left w-100" role="alert">
      <div v-for="(error, idx) in errors.flatten()" :key="idx">{{ error }}</div>
    </div>

    <div class="form-group pull-left w-100 mb-1">
      <div class="form-group w-100">
        <input v-model.trim="email" class="form-control mb-2" :placeholder="email_username" type="email" data-cy="loginEmail" @keydown.enter="login" />
        <input v-model="password" class="form-control mb-3" :placeholder="user_password" type="password" data-cy="loginPassword" @keydown.enter="login" />
        <div v-show="recaptcha_is_v2" id="captcha_button"></div>
      </div>
    </div>
    <div class="form-group pull-left w-100 mb-2 d-flex flex-column gap-4 mb-6">
      <span class="login-group">
        <button v-track="{ category: 'plan-builder', action: 'click', label: 'login' }" class="btn-lg btn btn-success fw-bold w-100" @keyup.enter="login" @click="login">{{ $t('account.login_continue') }}</button>
        <a class="lightgrey pull-left mt-1 text-noip-text-grey" v-track="{ category: 'plan-builder', action: 'click', label: 'forgot_password' }" href="/forgot-password">{{ $t('account.forgotpassword') }}</a>
      </span>

      <google-sign-in-button />
      <microsoft-sign-in-button />
    </div>
  </div>
</template>

<script>
import Errors from '../../../classes/errors';
import Captcha from '../../mixins/Captcha';
import GoogleSignInButton from './GoogleSignInButton';
import MicrosoftSignInButton from './MicrosoftSignInButton';

const AUTH_FAILURE = 'LOGIN_FAILURE';
const TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS';
const TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS';
const CAPTCHA_FAILURE = 'CAPTCHA_FAILURE';

export default {
  name: 'Login',

  mixins: [Captcha],

  components: {
    GoogleSignInButton,
    MicrosoftSignInButton
  },

  data() {
    return {
      email: '',
      password: '',
      errors: new Errors()
    };
  },
  computed: {
    email_username: function () {
      return this.$t('account.email_username');
    },
    user_password: function () {
      return this.$t('account.user_password');
    }
  },

  methods: {
    login() {
      this.submitCaptcha(this.postLogin);
    },

    postLogin() {
      let user = {
        'username': this.email,
        'password': this.password,
        'g-recaptcha-response': this.captcha_token
      };

      // eslint-disable-next-line no-undef
      axios
        .post('/login', user)
        .then(response => {
          if (Object.prototype.hasOwnProperty.call(response.data, 'error') && response.data.error) {
            if (response.data.error === CAPTCHA_FAILURE) {
              this.recaptcha_is_v2 = true;
            }
            this.setAuthErrors(response.data.error);
          } else if (response.data.goto) {
            window.location.replace(response.data.goto);
          } else if (response.data.success) {
            window.location.reload(true);
          }
        })
        .catch(() => {
          // TODO
        });
    },

    setAuthErrors(error) {
      let errors = {};

      if (error === AUTH_FAILURE) {
        errors.auth = this.$t('account.auth_failure');
      }

      if (error === TOO_MANY_REQUESTS) {
        errors.auth = this.$t('account.too_many_requests');
      }

      if (error === TOO_MANY_ATTEMPTS) {
        errors.auth = this.$t('account.too_many_attempts'); // TODO: format this long message
      }

      if (error === CAPTCHA_FAILURE) {
        errors.auth = this.$t('account.captcha_failure');
      }

      this.errors.set(errors);
    }
  }
};
</script>
